import { InvestmentObjectives } from '@interfaces/models/investment-objectives-types';
import { IKeyLabelPair } from '@interfaces/models/open-account-mfes/mfe-common.interfaces';

export const selectedPairsToObjectives = (pairs: IKeyLabelPair[]): InvestmentObjectives => {
  const keys = new Set(pairs.map((p) => p.key));
  return {
    CAP: keys.has('CAP') ? true : null,
    Income: keys.has('Income') ? true : null,
    Growth: keys.has('Growth') ? true : null,
    Speculation: keys.has('Speculation') ? true : null,
  };
};
